/** A player type (position) as returned by GET /sports/:sportId/types. */
export interface PositionType {
  id: string | number
  /** The API flags one type per sport as the default (1 / true). */
  is_default?: number | boolean
}

/**
 * Pick the position to pre-select when adding a player to a roster: the type the
 * API flags `is_default`, else the first one. Returns '' when the sport has no
 * types (the form then stays empty and the API rejects the save, as before).
 *
 * Returns a STRING because the roster form stores `positionId` as a string; the
 * payload transform parses it back to an int.
 *
 * Mirrors the existing default-position rule used by the registration flows
 * (`playerTypes.find((t) => t.is_default) || playerTypes[0]`).
 */
export const resolveDefaultPositionId = (
  positions: PositionType[] | undefined | null
): string => {
  if (!positions || positions.length === 0) {
    return ''
  }
  const preferred = positions.find((p) => Boolean(p.is_default)) ?? positions[0]
  return String(preferred.id)
}
